/**
 * 分类管理
 * Bai.Zhiming
 * 2019-6-18
 */
angular.module("hClassifyManagement", [
    "hClassifyManagementLeftModule",
]).
controller("hClassifyManagementCtrl", ['$scope', 'modalDialog', '$rootScope', '$timeout', 'hiddenCodeManagementService', 'trsHttpService', '$state', function($scope, modalDialog, $rootScope, $timeout, hiddenCodeManagementService, trsHttpService, $state) {
    initStatus();
    initData();
    /**
     * [goToChild description] 进入子分类
     * @param  {[type]} item [description] 子分类信息
     * @return {[type]}      [description]
     */
    $scope.goToChild = function(item) {
        let path = $state.params.classifypath;
        let pathArray = path.split(",");
        pathArray.push(item.id);
        $state.go("manageconfig.sysmanage.hiddencodemanagement.classifymanagement", { classifyid: item.id, classifypath: pathArray.join(",") }, { reload: "manageconfig.sysmanage.hiddencodemanagement.classifymanagement" })
        reloadLeft();
    };
    /**
     * [createClassify description] 新建分类
     * @return {[type]} [description]
     */
    $scope.createClassify = function(item) {
        let parentclassify = angular.isObject(item) ? item.parentclassify : undefined;
        let id = angular.isObject(item) ? item.id : undefined;
        hiddenCodeManagementService.createClassify(parentclassify).then(resp => {
            resp.parentid = $state.params.classifyid;
            resp.serviceid = "mlf_buridecode";
            resp.methodname = "saveClassify";
            resp.id = id;
            $scope.loadingPromise = hiddenCodeManagementService.httpServer(trsHttpService.getWCMRootUrl(), resp, 'post').then(resp => {
                $state.go("manageconfig.sysmanage.hiddencodemanagement.classifymanagement", $state.params, { reload: "manageconfig.sysmanage.hiddencodemanagement.classifymanagement" })
                reloadLeft();
            });
        });
    };
    /**
     * [deleteClassify description] 删除分类
     * @param  {[type]} item [description] 被删除的分类
     * @return {[type]}      [description]
     */
    $scope.deleteClassify = function(item) {
        modalDialog.alertType("分类被删除以后将不可恢复，确定要删除么？", "", "ask", true, () => {
            let params = {
                serviceid: "mlf_buridecode",
                methodname: "deleteClassify",
                id: item.id
            };
            $scope.loadingPromise = hiddenCodeManagementService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(resp => {
                $state.go("manageconfig.sysmanage.hiddencodemanagement.classifymanagement", $state.params, { reload: "manageconfig.sysmanage.hiddencodemanagement.classifymanagement" })
                reloadLeft();
            });
        });
    };

    function requestData() {
        $scope.loadingPromise = hiddenCodeManagementService.httpServer(trsHttpService.getWCMRootUrl(), $scope.params, 'get').then(resp => {
            $scope.data.items = resp.data;
            console.log(resp);
        });
    }
    /**
     * [initStatus description] 初始化状态
     * @return {[type]} [description]
     */
    function initStatus() {
        $scope.status = {

        };
        $scope.params = {
            serviceid: "mlf_buridecode",
            methodname: "get",
            parentid: $state.params.classifyid
        };
        $scope.data = {};
    }
    /**
     * [initData description] 初始化数据
     * @return {[type]} [description]
     */
    function initData() {
        requestData();
    }

    function reloadLeft() {
        $timeout(() => {
            $rootScope.$broadcast("leftReload", true);
        });
    }
}]);